// extracted by mini-css-extract-plugin
module.exports = {"light_gray":"#c3c3c3","noData":"style_noData__1HE_S"};